module.exports = __webpack_public_path__ + "img/jsszfcglogo.d743d735.png";